import { render, staticRenderFns } from "./WFDistributeConfigList.vue?vue&type=template&id=08411f6d&scoped=true"
import script from "./WFDistributeConfigList.vue?vue&type=script&lang=js"
export * from "./WFDistributeConfigList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08411f6d",
  null
  
)

export default component.exports